/**
 * Retrieves a value from a nested object based on a dynamic path string.
 *
 * The path can include dot notation (`.`) and bracket notation (`[]`), allowing access to both object properties and array indices.
 * For example, given an object `{ a: { b: [1, 2, 3] } }`, the path `"a.b[1]"` will return `2`.
 *
 * @param {Object} obj - The object to retrieve the value from.
 * @param {string} path - The path string specifying the location of the value within the object.
 * @returns {*} The value at the specified path, or `undefined` if the path is invalid or leads to a non-existent property.
 */
export const getValueFromPath = (obj, path) => {
  if (obj === undefined || obj === null) {
    return undefined
  }

  const parts = path.split(/[.[\]]+/).filter(Boolean) // Split by '.' and '[]'
  let current = obj

  for (const part of parts) {
    if (!isNaN(part)) {
      current = current[parseInt(part, 10)]
    } else {
      current = current[part]
    }

    if (current === undefined || current === null) {
      return undefined
    }
  }

  return current
}
